<div class="page-container p-2">
  <div class="back-link" routerLink="/proctoring-dashboard/proto-rules">
    <i class="bi bi-arrow-left"></i>
    Back
  </div>

  <ng-container *ngIf="isLoading; else showPage">
    <div class="app-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #showPage>
    <ng-container *ngIf="ruleSetDetails; else showMessage">
      <div class="header-section">
        <div>
          <h1 [matTooltip]="ruleSetDetails.name" matTooltipPosition="below">
          {{ (ruleSetDetails.name | slice:0:75) + (ruleSetDetails.name.length > 75 ? "..." : "") }}</h1>
          <p>Baseline proctoring configuration used across assessments.</p>
        </div>

        <button
          class="edit-btn"
          (click)="updateProctoringRuleset()"
          [disabled]="isSaving"
          *hasPermission="PermissionForStudents.PROCTORING_UPDATE"
        >
          <ng-container *ngIf="!isSaving; else saving">
            <i
              class="bi"
              [ngClass]="isEditing ? 'bi-check-lg' : 'bi-pencil'"
            ></i>
            {{ isEditing ? "Save Ruleset" : "Edit Ruleset" }}
          </ng-container>

          <ng-template #saving>
             <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span> ...Saving
          </ng-template>
        </button>
      </div>
            <form [formGroup]="rulesetEditForm">
        <div class="edit-summary-card" *ngIf="isEditing">
          <div class="field-group">
            <label>RULESET NAME<span>*</span></label>

            <input type="text" formControlName="name" />
            <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['required']">
                  Ruleset name is required.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['minLength']">
                  Ruleset name must contain at least 3 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['maxLength']">
                  Ruleset name cannot exceed 100 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['trimSpaces']">
                  Leading and trailing spaces are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['whitespace']">
                  Ruleset name cannot be empty.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['invalidCharacters']">
                  Invalid characters are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['firstCharacter']">
                  Ruleset name cannot start with a special character.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['duplicate']">
                  Ruleset name already exists.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="rulesetEditForm.get('name')?.touched && rulesetEditForm.get('name')?.errors?.['html']">
                  Invalid input detected.
                </small>
          </div>

          <div class="field-group purpose">
            <label>PURPOSE</label>

            <input type="text" formControlName="description" />
              <small
            class="smaller-text text-danger"
            *ngIf="rulesetEditForm.get('description')?.touched && rulesetEditForm.get('description')?.errors?.['maxLength']">
            Description cannot exceed 500 characters.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetEditForm.get('description')?.touched && rulesetEditForm.get('description')?.errors?.['trimSpaces']">
            Extra spaces will be removed.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetEditForm.get('description')?.touched && rulesetEditForm.get('description')?.errors?.['whitespace']">
            Please enter a valid description.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetEditForm.get('description')?.touched && rulesetEditForm.get('description')?.errors?.['invalidCharacters']">
            Invalid characters entered.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="rulesetEditForm.get('description')?.touched && rulesetEditForm.get('description')?.errors?.['html']">
            Invalid input detected.
          </small>
          </div>

          <div class="field-group total">
            <label>TOTAL RULES</label>

            <span>
              {{ ruleSetDetails.totalRules }}
            </span>
          </div>

           </div>
 <div class="default-card">
            <div>
              <div class="default-title">
                Set as default

              <span class="badge" *ngIf="ruleSetDetails.isDefault"> Default </span>
              </div>

              <p>
                Use this ruleset as the organization default for any assessment
                that doesn't specify one.
              </p>
            </div>

             <div
              class="switch"
              [class.active]="rulesetEditForm.get('isDefault')?.value"
              (click)="openDefaultsDialogBox()"
              [class.disabled]="!isEditing"
            >
              <span></span>
            </div>
        </div>
      </form>

      <div class="summary-card" *ngIf="ruleSetDetails">
        <div>
          <label>RULESET NAME</label>
          <span [matTooltip]="ruleSetDetails.name" matTooltipPosition="below">
          {{ (ruleSetDetails.name | slice:0:20) + (ruleSetDetails.name.length > 20 ? "..." : "") }}
          </span>
        </div>

        <div>
          <label>TOTAL RULES</label>
          <span>{{ ruleSetDetails.totalRules }}</span>
        </div>

        <div>
          <label>LAST UPDATED</label>
          <span>{{ ruleSetDetails.updatedAt | date: "dd MMM yyyy" }}</span>
        </div>

        <div>
          <label>STATUS</label>
          <span class="status">
            <span>{{ ruleSetDetails.isEnabled ? "Active" : "Inactive" }}</span>
          </span>
        </div>
      </div>

      <div class="rules-card">
        <div class="card-header">
          <div>
          <h3>Rule configuration</h3>
          <p>Read-only view of every proctoring rule in this ruleset.</p>
          </div>
          <button *ngIf="isEditing" class="edit-btn" (click)="openAddRuleDialog()" 
            [disabled]="allRulesAdded" 
            [matTooltip]="allRulesAdded ? 'All rules have been added' : ''">
            + Add Rule
          </button>
        </div>
        <table>
          <thead>
            <tr>
              <th>RULE</th>
              <th>DESCRIPTION</th>
              <th>SEVERITY</th>
              <th>DEBOUNCE (S)</th>
              <th>WINDOW (S)</th>
              <th>THRESHOLD</th>
              <th>ESCALATION</th>
              <th>
                CAPTURE SNAPSHOT
                <i class="bi bi-info-circle"></i>
              </th>
              <th>UPDATED</th>
              <th *ngIf="isEditing">ACTIONS</th>
            </tr>
          </thead>

          <tbody *ngIf="ruleSetDetails.rules.length; else noRules">
            <tr *ngFor="let rule of ruleSetDetails.rules">
              <td class="rule-name">
                <span [matTooltip]="rule.ruleName">
                  {{ (rule.ruleName || '').length > 25 ? ((rule.ruleName || '') | slice:0:25) + '...' : rule.ruleName || '-' }}
                </span>
                <!-- <input
                  *ngIf="isEditing"
                  [(ngModel)]="rule.ruleName"
                  class="table-input"
                /> -->
              </td>

              <td class="description">
                <span [matTooltip]="rule.description">
                  {{ (rule.description || '').length > 40 ? ((rule.description || '') | slice:0:40) + '...' : rule.description || '-' }}
                </span>
                <!-- <textarea
                  *ngIf="isEditing"
                  [(ngModel)]="rule.description"
                  class="table-input"
                >
                </textarea> -->
              </td>

              <td [class.editing-cell]="isEditing">
                <span
                  *ngIf="!isEditing"
                  class="severity"
                  [ngClass]="(rule.severity || '').toLowerCase()"
                >
                  <span></span>
                  {{ (rule.severity | titlecase) || "-" }}
                </span>

                <div *ngIf="isEditing">
                <select
                  [(ngModel)]="rule.severity"
                  #severity="ngModel"
                  required
                  [ngModelOptions]="{standalone: true}"
                  class="table-input"
                >
                  <option value="" disabled>Select Severity</option>
                  <option value="LOW">Low</option>
                  <option value="MEDIUM">Medium</option>
                  <option value="HIGH">High</option>
                  <option value="CRITICAL">Critical</option>
                </select>
                <small *ngIf="severity.invalid && (severity.dirty || severity.touched)" class="text-danger smaller-text mt-1 d-block" style="text-align: left;">
                   <span *ngIf="severity.errors?.['required']">Select Severity.</span>
                </small>
                </div>
              </td>

              <td [class.editing-cell]="isEditing">
                <span *ngIf="!isEditing">
                  {{ rule.debounceSeconds || "-" }}
                </span>

                <div *ngIf="isEditing">
                <input
                  type="number"
                  [(ngModel)]="rule.debounceSeconds"
                  class="small-input"
                  min="1"
                  max="300"
                  required
                  pattern="^[0-9]+$"
                  #debounce="ngModel"
                  [ngModelOptions]="{standalone: true}"
                  (keypress)="preventNonNumericalInput($event)"
                />
                <small *ngIf="debounce.invalid && (debounce.dirty || debounce.touched)" class="error-msg text-danger smaller-text mt-1 d-block">
                  <span *ngIf="debounce.errors?.['required']">Debounce is required.</span>
                  <span *ngIf="debounce.errors?.['min']">Debounce must be at least 1.</span>
                  <span *ngIf="debounce.errors?.['max']">Debounce cannot exceed 300.</span>
                  <span *ngIf="debounce.errors?.['pattern'] && !debounce.errors?.['min']">Debounce must be a whole number.</span>
                </small>
                </div>
              </td>

              <td [class.editing-cell]="isEditing">
                <span *ngIf="!isEditing">
                  {{ rule.thresholdWindowSeconds || "-" }}
                </span>

                <div *ngIf="isEditing">
                <input
                  type="number"
                  [(ngModel)]="rule.thresholdWindowSeconds"
                  class="small-input"
                  [min]="rule.debounceSeconds > 5 ? rule.debounceSeconds : 5"
                  max="600"
                  required
                  pattern="^[0-9]+$"
                  #window="ngModel"
                  [ngModelOptions]="{standalone: true}"
                  (keypress)="preventNonNumericalInput($event)"
                />
                <small *ngIf="(window.invalid || rule.thresholdWindowSeconds < 5 || rule.thresholdWindowSeconds > 600 || rule.thresholdWindowSeconds < rule.debounceSeconds) && (window.dirty || window.touched)" class="error-msg text-danger smaller-text mt-1 d-block">
                   <span *ngIf="window.errors?.['required']">Window is required.</span>
                   <span *ngIf="window.errors?.['min']">Window must be at least {{ rule.debounceSeconds > 5 ? rule.debounceSeconds : 5 }}.</span>
                   <span *ngIf="window.errors?.['max']">Window cannot exceed 600.</span>
                   <span *ngIf="window.errors?.['pattern'] && !window.errors?.['min']">Window must be a whole number.</span>
                </small>
                </div>
              </td>

              <td [class.editing-cell]="isEditing">
                <span *ngIf="!isEditing">
                  {{ rule.thresholdCount || "-" }}
                </span>

                <div *ngIf="isEditing">
                <input
                  type="number"
                  [(ngModel)]="rule.thresholdCount"
                  class="small-input"
                  min="1"
                  [max]="rule.thresholdWindowSeconds < 100 ? rule.thresholdWindowSeconds : 100"
                  required
                  pattern="^[0-9]+$"
                  #threshold="ngModel"
                  [ngModelOptions]="{standalone: true}"
                  (keypress)="preventNonNumericalInput($event)"
                />
                <small *ngIf="(threshold.invalid || rule.thresholdCount > 100) && (threshold.dirty || threshold.touched)" class="error-msg text-danger smaller-text mt-1 d-block">
                   <span *ngIf="threshold.errors?.['required']">Threshold is required.</span>
                   <span *ngIf="threshold.errors?.['min']">Threshold must be at least 1.</span>
                   <span *ngIf="threshold.errors?.['max'] || rule.thresholdCount > 100">Threshold cannot exceed {{ rule.thresholdWindowSeconds < 100 ? rule.thresholdWindowSeconds : 100 }}.</span>
                   <span *ngIf="threshold.errors?.['pattern'] && !threshold.errors?.['min']">Threshold must be a whole number.</span>
                </small>
                </div>
              </td>

              <td [class.editing-cell]="isEditing">
                <span *ngIf="!isEditing">
                  {{ (rule.escalationAction | titlecase) || "-" }}
                </span>

                <div *ngIf="isEditing">
                <select
                  [(ngModel)]="rule.escalationAction"
                  #escalation="ngModel"
                  required
                  [ngModelOptions]="{standalone: true}"
                  class="table-input"
                >
                  <option value="" disabled>Select Escalation</option>
                  <option value="WARN">Warn</option>
                  <option value="CANCEL">Cancel</option>
                  <option value="BLOCK">Block</option>
                </select>
                <small *ngIf="escalation.invalid && (escalation.dirty || escalation.touched)" class="text-danger smaller-text mt-1 d-block" style="text-align: left;">
                   <span *ngIf="escalation.errors?.['required']">Select an Escalation level.</span>
                </small>
                </div>
              </td>

              <td [class.editing-action-cell]="isEditing">
                <div
                  class="switch"
                  [class.active]="rule.captureSnapshot"
                  (click)="
                    isEditing && (rule.captureSnapshot = !rule.captureSnapshot)
                  "
                >
                  <span></span>
                </div>
              </td>

              <td [class.editing-action-cell]="isEditing">
                {{ rule.updatedAt | date: " dd MMM yyyy" }}
                </td>
                <td [class.editing-action-cell]="isEditing">
                <ng-container *hasPermission="PermissionForStudents.PROCTORING_DELETE">
                <span *ngIf="isEditing" class="ms-3">
                  <i class="bi bi-trash" (click)="openDeleteDialogBox(rule.ruleSetId,rule.ruleId,rule.ruleName)"></i>
                </span>
                </ng-container>

                  <ng-container *hasPermission="PermissionForStudents.PROCTORING_UPDATE">
                 <span *ngIf="isEditing" class="ms-3 test">
                  <i class="bi bi-save" (click)="updateProctoringRulesetById(rule)"></i>
                </span>
                </ng-container>
              </td>
            </tr>
          </tbody>

          <ng-template #noRules>
            <tbody>
              <tr>
                <td colspan="9" class="text-center">No rules available.</td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </ng-container>
    <ng-template #showMessage> no ruleset available </ng-template>
  </ng-template>
</div>